import { EventManager } from '../event-manager.class'

const ChannelPipe = typeof window !== 'undefined' && window.BroadcastChannel ? window.BroadcastChannel : class Dummy{ postMessage() {}}
const _tab_events = new EventManager()
const isIE = false
let channel = null

if (!isIE) {
  channel = new ChannelPipe('_inface_browser_coummunicate')
  channel.onmessage = (eventObject) => {
    _tab_events.dispatch('_raw_message', eventObject && eventObject.data)
  }
}

export class BrowserCommunicator {
  constructor(tabID) {
    this._tabID = tabID || 'UNKNOWN_BROWSER_TAB_ID'
    this._isLocalStorageMode = isIE // for ie
    this._events = new EventManager()
    _tab_events.addEventListener('_raw_message', this.onReceivedRawMessage.bind(this))
  }

  get events() {
    return this._events
  }

  onReceivedRawMessage(_rawEventObject) {
    const eventObject = _rawEventObject
    if (!eventObject) {
      return
    }
    this._events.dispatch('message', eventObject)
  }

  dispatch(commandObject) {
    if (!commandObject) {
      return
    }
    const event = {
      targetID: commandObject.targetID,
      fromID: this._tabID,
      type: commandObject.type,
      data: JSON.parse(JSON.stringify(commandObject.data))
    }
    if (!isIE && channel) {
      channel.postMessage(event)
      // 자기 자신에게도 메시지를 전달해야 함 (gc toggle 등)
      this.onReceivedRawMessage(event)
    }
  }
}
